import { createApiClient } from '@mevaser/shared'

/**
 * In development Vite proxies /api to the API server, so the browser sees one
 * origin and cookies behave exactly as they will in production behind Caddy.
 */
const baseUrl = import.meta.env.VITE_API_URL ?? '/api'

/**
 * The same base, for the rare caller that must NOT go through the client below.
 * `api` turns a 401 into a redirect to /login, which is right for anything the
 * user asked for and wrong for background work: the support widget checking
 * whether it is switched on must never be able to sign anyone out.
 */
export const apiBaseUrl = baseUrl

let unauthorizedHandler: (() => void) | null = null

export function setUnauthorizedHandler(handler: () => void): void {
  unauthorizedHandler = handler
}

export const api = createApiClient({
  baseUrl,
  onUnauthorized: () => unauthorizedHandler?.(),
})
